module.exports = __webpack_public_path__ + "img/19.0bfa069d.png";